import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { useMemo, useState } from "react";
import useProcessData from "../../../CommonFunction/ProcessData";
import { Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import LoadTable from "../../Components/LoadTable/LoadTable";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

const queryfunction = (fields: []) => {
  const query = gql`
  query getAllConnectionMemoUpdate_WithPopulate {
    getAllConnectionMemoUpdate_WithPopulate {
        _id
     ${fields?.join(" ")}
        }
        }    
        `;
  return query;
};
// const AllData = gql`
//   query getAllConnectionMemoUpdate_WithPopulate {
//     getAllConnectionMemoUpdate_WithPopulate {
//       _id
//       Unique_Id
//       Date
//       Memo_No
//       Vehicle_No
//       Connection_No
//     }
//   }
// `;

const ConnectionStatusUpdate = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState([]);
  const Key = "Connection_Memo_Updation";
  const config = useMemo(
    () => ({
      dataKey: "getAllConnectionMemoUpdate_WithPopulate",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename", "is_Audit"],
      dateKeysWithoutTime: ["Date"],
    }),
    []
  );

  const [fetchAccountGroup, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([]), {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });
  const { loading, TableHeaders } = useFetchTableData(queryfunction, fetchAccountGroup, setIsLoading, Key);
  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);
  // const isLoading = queryLoading || processDataLoading;

  if (error?.message) {
    return (
      <>
        <HeaderDiv title={"Connection Status Update"} TableKey={Key} />
        <p className="DataNotAvailable">{error.message}</p>
      </>
    );
  }

  return (
    <div>
      <HeaderDiv title="Connection Status Update" TableKey={Key} />
      {isLoading ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {(queryLoading || loading) && <div className="loader-line-div" />}
          <LoadTable title={Key} data={formData} loading={isLoading} error={error} TableHeaders={TableHeaders} />
        </>
      )}
    </div>
  );
};

export default ConnectionStatusUpdate;
